/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'gatsby';

import { StyledBlogList, StyledBlogListContent } from './BlogListStyles.js';
import { Headline, Details, HeaderImage, ContentTruncated } from '../atoms';

const BlogList = data => {
  const renderBlogList = data.map(post => {
    const { uid } = post.node._meta;
    const { blog_headline, author, tags, blog_post_date, blog_header_image, blog_post_content } = post.node;
    return (
      <StyledBlogList key={uid}>
        <Link to={`/blog/${uid}`}>{HeaderImage(blog_header_image, 'list')}</Link>
        <StyledBlogListContent>
          {Headline(blog_headline, uid, 'bloglist')}
          {Details(author, tags, blog_post_date, 'bloglist is-hidden-mobile')}
          {ContentTruncated(blog_post_content, uid)}
        </StyledBlogListContent>
      </StyledBlogList>
    );
  });

  return renderBlogList;
};

export default BlogList;
